/**
 * Specifies the action taken or to be taken for the specified instrument or list of instruments.
 * tag: 980
 * @readonly
 * @enum {string} (char)
 */
export enum SecurityUpdateAction {
  /** Add */
  Add = 'A',
  /** Delete */
  Delete = 'D',
  /** Modify */
  Modify = 'M',
}
